<template>
  <div class="container-md">
    <div class="container-bg p-5" v-if="!sent">
      <h3 class="text-uppercase mb-4">Nieuwe Email</h3>
      <div class="row email p-3 mb-3">
        <div class="col-12 col-md-2 pt-2">Van:</div>
        <div class="col-12 col-md-10">
          <select
            class="w-100 form-control"
            style="height: 40px"
            v-model="email.from_name"
            v-if="allFromCommittees.length > 0"
          >
            <option value="">-- Standaard afzender --</option>
            <option
              :value="
                communityname + ' - ' + this.$store.state.auth.user.display_name
              "
            >
              {{ this.$store.state.auth.user.display_name }}
            </option>
            <option
              v-for="committeegroup in allFromCommittees"
              :key="'committeegroup_option_' + committeegroup.id"
              :value="communityname + ' - ' + committeegroup.title"
              :disabled="committeegroup.parent_id == 0"
            >
              {{ committeegroup.title }}
            </option>
          </select>
        </div>
      </div>

      <div class="row email p-3 mb-3">
        <div class="col-12 col-md-2 pt-2">Antwoord aan:</div>
        <div class="col-12 col-md-10">
          <select
            class="w-100 form-control"
            style="height: 40px"
            v-model="email.reply"
          >
            <option
              v-for="(reply, index) in replies"
              :key="'replie' + index"
              :value="reply"
            >
              {{ reply }}
            </option>
          </select>
        </div>
      </div>

      <div class="row email">
        <div class="col-12">
          <div class="row p-3">
            <div class="col-12 col-md-2 pt-2">Aan:</div>
            <div class="col-12 col-md-10">
              <div
                class="row mb-3"
                v-if="userHasPermissions(['Email Alle Leden']) == true"
              >
                <div class="col-12">
                  <Select2
                    @select="pickMember($event)"
                    :options="
                      activeMembers.map((d) => {
                        return { id: d.id, text: d.display_name };
                      })
                    "
                  ></Select2>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <ul class="to-buttons">
                    <li class="dropdown show ml-0" v-if="showAlgemeen">
                      <a
                        class="btn btn-dark text-white dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Algemeen
                      </a>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="members_active"
                            :value="email.members_active"
                            v-on:change="toggleMemberActive()"
                          />
                          <label class="form-check-label" for="members_active"
                            >Actieve leden</label
                          >
                        </a>
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="members_old"
                            :value="email.members_old"
                            v-on:change="toggleMemberOld()"
                          />
                          <label class="form-check-label" for="members_old"
                            >Oud leden</label
                          >
                        </a>
                      </div>
                    </li>

                    <li
                      class="dropdown show"
                      v-for="committeegroup in allCommitteesFiltered"
                      :key="committeegroup.id"
                    >
                      <a
                        class="btn btn-dark text-white dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ committeegroup.title }}
                      </a>

                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          v-for="committee in committeegroup.children"
                          :key="committee.id"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :id="'committee_' + committee.id"
                            :value="committee.id"
                            v-on:change="toggleCommittee(committee)"
                          />
                          <label
                            class="form-check-label"
                            :for="'committee_' + committee.id"
                            >{{ committee.title }}</label
                          >
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-12 p-0 mb-3" v-if="to">
                <div class="row">
                  <div class="col-8">
                    <div class="row">
                      <div
                        class="col-4"
                        v-for="group in to"
                        v-bind:key="'group_to_name_' + group.title"
                      >
                        {{ group.title }}
                        <ul class="p-0">
                          <li
                            class="round-class mr-1 mb-1"
                            v-bind:class="{
                              disabled: inRemovedMembers(member),
                              'bg-danger':
                                member.allow_email == 0 ? true : false,
                            }"
                            v-for="member in group.members"
                            v-bind:key="
                              'group_to_name_' + group.title + '_' + member.id
                            "
                            v-on:click="toggleRemoveMemberTo(member)"
                          >
                            <span class="mr-2" aria-hidden="true"
                              >&times;
                            </span>
                            {{ member.display_name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <p class="tip">
                      Wilt u specifieke personen uit deze groep niet mailen,
                      klik dan op de ‘x’. De box wordt zwart en de persoon zal
                      niet gemaild worden.<br />Als de achtergrond rood is kan
                      het lid geen mail ontvangen
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row email p-3 mt-3">
        <div class="col-12 col-md-2 pt-2">Onderwerp:</div>
        <div class="col-12 col-md-10">
          <input
            type="text"
            class="w-100 form-control"
            style="height: 40px"
            v-model="email.subject"
          />
          <p v-if="this.error" class="text-danger mt-2">{{ this.error_msg }}</p>
        </div>
      </div>

      <div class="row email p-3 mt-3">
        <div class="col-12 col-md-2 pt-2">Bijlage:</div>
        <div class="col-12 col-md-10">
          <div class="form-group">
            <input
              type="file"
              @change="fileselected()"
              class="form-control"
              id="file"
            />
          </div>
          <div class="row">
            <div class="col-12">
              <ol>
                <li v-for="(file, index) in files" :key="index">
                  {{ file.name }}
                  <a
                    class="ml-2 text-danger"
                    @click="removeFile(file.id)"
                    href="javascript:void(0)"
                    ><i class="fas fa-times"></i
                  ></a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="row email p-3 mt-3">
        <div class="col-12 col-md-2 pt-2">Bericht:</div>
        <div class="col-12 col-md-10">
          <editor
            id="contact_remarks"
            v-model="email.body"
            :init="{
              height: 300,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | removeformat | help',
            }"
          />
        </div>
      </div>
      <div class="row email p-3 mt-3">
        <div class="col-12 col-md-10">
          <span class="text-muted">Van</span><br /><span
            v-if="this.email.from_name == ''"
            >Standaard afzender</span
          ><span v-else>{{ this.email.from_name }}</span>
          <hr />
        </div>
        <div class="col-12 col-md-10">
          <span class="text-muted">Aan</span><br />
          <ul>
            <li
              v-for="(user, ind) in emailTo"
              :key="'emailTo' + ind + '_' + user.id"
            >
              {{ user.display_name }}
            </li>
            <li v-if="email.members_active">Alle leden</li>
            <li v-if="email.members_old">Oud leden</li>
            <li v-if="email.members_me">
              {{ this.$store.state.auth.user.display_name }}
            </li>
            <li v-if="email.me">
              {{ this.$store.state.auth.user.display_name }}
            </li>
            <li v-for="committee in email.committees" :key="committee.id">
              {{ committee.title }}
            </li>
          </ul>
          <hr />
        </div>
        <div class="col-12 col-md-10">
          <span class="text-muted">Onderwerp</span><br />{{
            this.email.subject
          }}
          <hr />
        </div>
        <div class="col-12 col-md-10" v-if="this.email.attachements">
          <span class="text-muted">Bijlagen</span><br />{{
            this.email.attachements
          }}
          <hr />
        </div>
        <div class="col-12 col-md-10">
          <span class="text-muted">Bericht</span><br />
          <div v-html="emailPreview"></div>
        </div>
        <div class="col-12 col-md-2 d-flex align-items-end">
          <div class="">
            <button class="btn btn-dark text-white" v-on:click="postMail">
              <loader></loader>
              <span v-if="!this.loader">Verstuur</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-bg p-5" v-if="sent">
      <h3 class="text-uppercase mb-4">Bericht verwerkt...</h3>
      <a class="btn btn-dark text-white" href="/community/email">Terug</a>
    </div>
  </div>
</template>

<script>
import loader from "../../helper/loader";
import { mapState } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "email",
  components: { loader },
  data() {
    return {
      email: {
        from_name: process.env.VUE_APP_COMUNITY,
        subject: "",
        body:
          "<p></p><p>Met vriendelijke groet,<br>" +
          process.env.VUE_APP_COMUNITY +
          "</p>" +
          process.env.VUE_APP_MAIL_FOOTER,
        users: [],
        committees: [],
        members_active: 0,
        active_members: [],
        members_old: 0,
        old_members: [],
        members_me: 0,
        reply: null,
      },
      error: false,
      error_msg: "",
      allMembers: [],
      allCommittees: [],
      allCommitteesWithUsers: [],
      activeMembers: [],
      oldMembers: [],
      toMembers: [],
      sent: false,
      files: [],
      to: [],
      removedMembersFromTo: [],
      emailTo: [],
      communityname: process.env.VUE_APP_COMUNITY,
      today: null,
      emailaddresses: [],
      replies: [],
    };
  },
  async mounted() {
    this.email.from_name = `${this.communityname} - Vereniging`;
    await axios.get("/api/v1/today").then((response) => {
      this.today = response.data.today;
    });
    axios.get("/api/v1/get-reply-to-emails").then((response) => {
      /* response.data.data.forEach(item => {
                    this.replies.push({
                     id: item.email,
                     text: item.email
                  })
                }) */

      response.data.data.forEach((item) => {
        this.replies.push(item.email);
        if (item.default == 1) this.email.reply = item.email;
      });
    });

    axios.get("/api/v1/committees").then((response) => {
      this.allCommittees = response.data.data;
    });

    axios.get("/api/v1/committees/members").then((response) => {
      this.allCommitteesWithUsers = response.data.data;
    });
    // Pull current users
    this.$store
      .dispatch("get", "/api/v1/users/all")
      .then((data) => {
        this.allMembers = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });

    // Pull current users
    this.$store
      .dispatch("get", "/api/v1/active/users")
      .then((data) => {
        this.activeMembers = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
    // Pull old users
    this.$store
      .dispatch("get", "/api/v1/inactive/users")
      .then((data) => {
        this.oldMembers = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
  },
  methods: {
    removeFile(id) {
      this.files = this.files.filter((d) => d.id != id);
    },
    fileselected() {
      var file = document.getElementById("file");
      if (file.files.length > 0) {
        file = file.files[0];
        file.id = Math.floor(Math.random() * 999999);

        var filereader = new FileReader();
        var context = this;
        var content = "";
        filereader.onload = (result) => {
          content = result.srcElement.result;
          // content=content.split(';base64,');

          context.files.push({
            name: file.name,
            content: content,
          });
          console.log(context.files);
        };
        filereader.readAsDataURL(file);
      }
    },
    postMail() {
      // const gretting = process.env.VUE_APP_DEFAULT_EMAIL_GREETING;
      if (this.email.subject.trim().length == 0) {
        this.error = true;
        this.error_msg = "Onderwerp is verplicht";
        return false;
      }

      if (this.email.body.trim().length == 0) {
        this.error = true;
        this.error_msg = "Bericht is verplicht";
        return false;
      }
      this.email.users = this.emailTo;
      this.email.files = this.files;
      this.$store.dispatch("postMail", this.email);
      //this.sent = true;
    },

    pickMember(obj) {
      var tmp = this.allMembers.filter(function(user) {
        return user.id == obj.id;
      });
      this.toMembers[obj.id] = tmp[0];
      this.updateTo();
    },
    inRemovedMembers(obj) {
      return this.removedMembersFromTo.includes(obj);
    },
    toggleRemoveMemberTo(obj) {
      if (this.inRemovedMembers(obj)) {
        this.removedMembersFromTo = this.removedMembersFromTo.filter(function(
          member
        ) {
          return member.id != obj.id;
        });
      } else {
        this.removedMembersFromTo.push(obj);
      }
      this.updateTo();
    },
    toggleMemberActive() {
      if (this.email.members_active) {
        this.email.members_active = 0;
      } else {
        this.email.members_active = 1;
      }
      this.updateTo();
    },
    toggleMemberOld() {
      this.email.members_old = this.email.members_old ? 0 : 1;
      this.updateTo();
    },
    toggleCommittee(obj) {
      var comittees = this.email.committees.filter(function(committee) {
        return committee.id != obj.id;
      });
      if (comittees.length !== this.email.committees.length) {
        this.email.committees = comittees;
      } else {
        this.email.committees.push({ id: obj.id, title: obj.title });
      }
      this.updateTo();
    },
    getCommitteeUsers(obj) {
      let com = this.allCommitteesWithUsers.filter(function(committee) {
        return committee.id == obj.id;
      });
      return com;
    },
    updateTo() {
      var groups = [];
      var emailToPrep = [];
      var thas = this;
      var emailTo = [];
      var validMembers;

      if (this.toMembers.length) {
        var members = [];

        this.toMembers.forEach((member) => {
          members.push(member);
          emailToPrep.push(member);
        });
        if (members.length > 0) {
          validMembers = members.filter((m) => {
            return (
              m.member_end == null ||
              moment(m.member_end).isAfter(moment(this.today))
            );
          });
          groups.push({ title: "Aan", members: validMembers });
        }
      }
      if (this.email.members_old) {
        validMembers = this.oldMembers.filter((m) => {
          let d = m.member_end
            .split("-")
            .reverse()
            .join("-");

          return m.member_end != null && moment(d).isBefore(moment(this.today));
        });
        groups.push({ title: "Oud leden", members: validMembers });
        emailToPrep = emailToPrep.concat(this.oldMembers);
      }

      if (this.email.members_active) {
        validMembers = this.activeMembers.filter(function(m) {
          return thas.listUser(m);
        });
        groups.push({ title: "Actieve leden", members: validMembers });
        emailToPrep = emailToPrep.concat(this.activeMembers);
      }

      if (this.email.committees) {
        this.email.committees.forEach(function(committee) {
          let t = thas.getCommitteeUsers(committee);
          let usr = t[0].users;
          validMembers = usr.filter(function(m) {
            return thas.listUser(m);
          });
          groups.push({ title: committee.title, members: validMembers });
          emailToPrep = emailToPrep.concat(usr);
        });
      }

      emailToPrep.forEach(function(to) {
        if (!thas.inRemovedMembers(to)) {
          emailTo.push(to);
        }
      });
      this.emailTo = emailTo;
      this.to = groups;
    },
    listUser(user) {
      return user.member_end == null || this.email.members_old
        ? true
        : moment(user.member_end).isAfter(moment(this.today));
    },
  },
  computed: {
    ...mapState({
      loader: (state) => state.auth.loader,
      user: (state) => state.auth.user,
    }),
    showAlgemeen() {
      return (
        this.$store.state.auth.user.committees.includes(4) ||
        this.userHasPermissions([
          "Email Actieve Leden",
          "Ledenadministratie",
          "Email Oud Leden",
        ])
      );
    },
    showVereniging() {
      return (
        this.$store.state.auth.user.committees.includes(4) ||
        this.userHasPermissions([
          "Email Actieve Leden",
          "Email Alle Leden",
          "Email Oud Leden",
        ])
      );
    },
    emailPreview() {
      const gretting = process.env.VUE_APP_DEFAULT_EMAIL_GREETING;
      return (
        "<p>"+ gretting === undefined ? '' : gretting +", </p>" +
        this.email.body
      );
    },
    allFromCommittees() {
      var all = [];
      if (this.allCommittees) {
        this.allCommittees.forEach((committeegroup) => {
          if (
            committeegroup?.children?.length != 0 &&
            committeegroup.children[0].parent_id == 3
          ) {
            committeegroup.children.forEach((committee) => {
              if (
                this.userHasRoles(["Super-Admin"]) ||
                committee.users.some(
                  (user) => user.id == this.$store.state.auth.user.id
                )
              ) {
                all.push(committee);
              }
            });
          }
        });
      }
      if (this.showVereniging) {
        all.push({
          title: "Vereniging",
          id: "",
        });
      }
      return all;
    },
    allCommitteesFiltered() {
      let allComs = this.allCommittees.filter(function(committee) {
        return committee.id != 1;
      });

      return allComs;

      /* let all = [];
      allComs.forEach((item) => {
        let coms = [];
        if (
          item.children &&
          item.children.length > 0 &&
          item.children[0].parent_id == 2
        ) {
          coms = item.children.filter((cm) => {
            return (
              this.userHasRoles(["Super-Admin"]) ||
              cm.users.some((user) => user.id == this.$store.state.auth.user.id)
            );
          });
          item.children = coms;
        }

        all.push(item);
      });

      return all; */
    },
  },
  watch: {
    "email.members_active": function() {
      this.email.active_members = this.activeMembers;
    },
    "email.members_old": function() {
      this.email.old_members = this.members_old;
    },
  },
};
</script>

<style scoped>
.select2-container {
  width: 100%;
}
.email {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #c4c7d5;
  border-radius: 4px;
}

.dropdown-item {
  border-bottom: 1px solid;
}

.dropdown-menu {
  border: 1px solid;
  padding: 0;
  transform: translate3d(0px, 41px, 0px) !important;
}

.to-buttons {
  list-style-type: none;
  padding-left: 0px;
}

.to-buttons li {
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
}
.to-buttons li a {
  min-width: 150px;
}

.round-class {
  background-color: #4192da;
  border-radius: 21px;
  color: white;
  padding: 5px 16px;
  position: relative;
  font-weight: bold;
}
.round-class.disabled {
  background-color: #000;
  color: #fff;
}

.cursor {
  cursor: pointer;
  position: absolute;
  right: 14%;
  font-weight: bold;
}
.select2-container .select2-selection--single {
  height: 40px !important;
}
.tip {
  border: 1px solid;
  padding: 5%;
}
</style>
